import { render, staticRenderFns } from "./NewValueSelector.vue?vue&type=template&id=54a1ab5b&scoped=true&"
import script from "./NewValueSelector.vue?vue&type=script&lang=ts&"
export * from "./NewValueSelector.vue?vue&type=script&lang=ts&"
import style0 from "./NewValueSelector.vue?vue&type=style&index=0&id=54a1ab5b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a1ab5b",
  null
  
)

export default component.exports